import constants from '@/app-configs/constants'

export default [
  {
    title: 'DEBTIA_AKS_NON_REGISTERED_DEBTORS',
    icon: 'UserIcon',
    action: constants.action.permissionLogin,
    resource: constants.resource.user,
    companyOnly: true,
    route: 'aks-non-registered-debtors',
  },
]
